import { IDish } from "../interfaces/api/ambrosia/IMealOption"
import { DishNutritionInfoActionsTypes } from "../constants/actionTypes"

function init(): Record<string, IDish> {
	return {} as Record<string, IDish>
}

export const dishNutritionInfoReducer = function (initialState = init(), action: any) {
	switch (action.type) {
		case DishNutritionInfoActionsTypes.UPDATE_DISH_NUTRITION_INFO:
			return {
				...initialState,
				...(action.payload || {}),
			}
		default:
			return initialState
	}
}
